import React from "react";

export function Separator() {
  return <div className={"h-[0.5px] w-[50%] bg-black dark:bg-white"} />;
}
